import React, { ReactElement } from 'react';
import styled, { css } from 'styled-components';
import { ButtonTypes, ButtonProps } from '../../types/button.types';

function Button({ className, children, onClick, ...rest }: ButtonProps): ReactElement {
  return (
    <Container className={className} {...rest} onClick={onClick}>
      {children}
    </Container>
  )
}

export default Button;

const Container = styled.button<ButtonTypes>`
  border: none;
  border-radius: 5px;
  cursor: pointer;

  ${({
    width,
    height,
    backgroundColor,
    color,
    fontSize,
  }) => css`
    width: ${width};
    height: ${height};
    background-color: ${backgroundColor};
    color: ${color};
    font-size: ${fontSize};
  `}

  &:hover {
    ${({
      colorHover,
      backgroundColorHover
    }) => css`
      color: ${colorHover};
      background-color: ${backgroundColorHover};
    `}
  }
`